module.exports = __webpack_public_path__ + "static/media/favicon.5036ea76.ico";